import { PointageState, POINTAGES_STORE as s } from './type';
import { MutationTree } from 'vuex';
import { Pointage } from '@/models/Pointage';
import { TarifEventSchedulerActiviteDocument } from '@/models/TarifEventSchedulerActiviteDocument';
import { PaletteDocument } from '@/models/PaletteDocument';
import { TarifActiviteDocument } from '@/models/TarifActiviteDocument';
import { Supplement } from '@/models/Supplement';
import { GroupeIndividu } from '@/models/GroupeIndividu';
import { VieQuotidienneDocuments } from '@/models/VieQuotidienneDocument';
import { Individu } from '@/models/Individu';

export const mutations: MutationTree<PointageState> = {
    [s.SET_POINTAGE_ENCOURS](state, pointageEnCours: Array<Pointage>) {
        state.pointageEnCours = pointageEnCours;
    },
    [s.ADD_POINTAGE_ENCOURD](state, pointage: Pointage) {
        state.pointageEnCours.push(pointage);
    },
    

    [s.SET_LIST_TEMPS_ACCUEIL](state, newval: Array<TarifEventSchedulerActiviteDocument>) {
        state.listTempsAccueil = newval;
    },

    [s.SET_LIST_SUPPLEMENTS](state, newval: Array<TarifActiviteDocument>) {
        state.listSupplements = newval;
    },

    [s.SET_LIST_TEMPS_ACCUEIL_FILTRED](state, newval: Array<TarifEventSchedulerActiviteDocument>) {
        state.listTempsAccueilFiltred = newval;
    },

    [s.SET_LIST_SUPPLEMENTS_FILTRED](state, newval: Array<TarifActiviteDocument>) {
        state.listSupplementsFiltred = newval;
    },

    [s.SET_POINTAGE_PREVI](state, newval: Array<any>) {
        state.listPointagesPrevi = newval;
    },

    [s.SET_PALETTE_ENCOURS](state, newval: PaletteDocument) {
        state.paletteEncours = newval;
    },

    [s.SET_SUPPLEMENTS_ACTIFS](state, newval: Array<Supplement>) {
        state.listSupplementsActifs = newval;
    },
    [s.SET_LAST_ACTION](state, newval: any) {
        state.lastAction = newval;
    },
    [s.SET_POINTAGE_REEL](state, newval: Array<Pointage>) {
        state.pointageEnCours.length !== 0 ?
            state.pointageEnCours.concat(newval) :
            state.pointageEnCours = newval;
    },
    [s.SET_LIST_PALETTE_PRESENCE](state, newval: Array<PaletteDocument>) {
        state.listPalettePresence = newval;
    },
    [s.SET_LIST_PALETTE_ABSENCE](state, newval: Array<PaletteDocument>) {
        state.listPaletteAbsence = newval;
    },
    [s.SET_LIST_GROUPES](state, newval: Array<GroupeIndividu>) {
        state.listGroupes = newval;
    },
    [s.SET_LIST_REGIM](state, newval: Array<VieQuotidienneDocuments>) {
        state.listRegim = newval;
    },
    [s.SET_VIE_REGIM_ALI](state, newval: Array<string>) {
        state.vieQuoRegimeAli = newval;
    },
    [s.SET_SUPPLEMENTS_PREVI](state, newval: Array<any>) {
        state.listSupplementsPrevi = newval;
    },
    [s.SET_INDIVIDUS_PRESENT](state, newval: Array<Individu>) {
        state.individusPresents = newval;
    },
    [s.SET_INDIVIDUS_FILTREES_PRESENT](state, newval: Array<Individu>) {
        state.individusFiltreesPresents = newval;
    },
    

}